import { Spinner } from '@cian/ui-kit';

import * as React from 'react';

import styles from './LoadingContent.css';

export const LoadingContent: React.FC = () => {
  return (
    <div className={styles['container']} data-testid="loading-content">
      <Spinner color="icon-secondary-default" />
    </div>
  );
};
